// Resolve the base URL for our self-hosted detector assets (vision_bundle.mjs,
// wasm/, blaze_face_short_range.tflite) from the ORIGIN of the running embed
// script — never hardcoded — so it works in dev (:5174) and in prod where the
// deploy rsync ships src/widget/embed/ → /widget/ on our own origin.
//
// Layout invariant (see scripts/copy-models.mjs):
//   prod:  <origin>/<dir>/embed.js  ->  <origin>/<dir>/models/
//   dev:   <origin>/src/new-widget-entry.tsx  (vite) -> <origin>/embed/models/
//
// Returns a trailing-slash URL. Falls back to same-origin /embed/models/.

function findEmbedScript(): HTMLScriptElement | null {
  const byId = document.getElementById('beauty-advisor-widget');
  if (byId instanceof HTMLScriptElement) return byId;

  const tagged = document.querySelector<HTMLScriptElement>(
    'script[data-clinic-slug][src*="embed.js"], script[data-clinic-slug][src*="widget.js"]',
  );
  if (tagged) return tagged;

  if (document.currentScript instanceof HTMLScriptElement) {
    return document.currentScript;
  }
  return null;
}

export function resolveModelAssetBase(): string {
  const fallback = (origin: string) => new URL('/embed/models/', origin).href;

  try {
    const script = findEmbedScript();
    const src = script?.src;
    if (src) {
      const url = new URL(src, window.location.href);
      // Dev: vite serves the raw TSX entry from /src/*. Assets live at /embed/models/.
      if (/\/src\/.*\.(?:tsx?|jsx?)(?:$|\?)/.test(url.pathname)) {
        return fallback(url.origin);
      }
      // Prod: models sit next to the built embed.js / widget.js.
      return new URL('./models/', url.href).href;
    }
  } catch {
    /* fall through to same-origin default */
  }
  return fallback(window.location.origin);
}
